export default "__VITE_ASSET__BPHAa4RD__"